module.exports = __webpack_public_path__ + "media/reskin-images/icon--shield-keyhole-5e277e2a.svg";